import React, { useEffect, useState } from "react";
import PermissionHelper from "../../../components/Onboarding/components/PermissionHelper";
import { ReactComponent as PencilIcon } from "../assets/pencilIcon.svg";
import BasicSelect from "../../Task/BasicSelect";
import { ReactComponent as BackArrowIcon } from "../assets/backArrow.svg";
import { ReactComponent as SecurityIcon } from "../assets/securityIcon.svg";
import InputComponent from "../../UniversalComponents/InputComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { CHECK_ORG_DUPLICATE, NODE_URL, SIGNUP_URL, SIGNUP_URL_GOOGLE } from "../../../utils/constants";
import { Password } from "@mui/icons-material";
import { addParticularCompany, addUser, addUserCompanyAccess, updateUser } from "../../../utils/userSlice";
import { useLazyFetchCompanyPermissionsQuery } from "../../../utils/customer/customerTable";
import { getUserId, getUserToken } from "../../../utils/utilityFunctions/localServices";
import { useDispatch } from "react-redux";
import LoaderGif from "../assets/loader.gif";
import { useBulkAssignSignupMutation } from "../../../utils/company/companypermissions";

const CompanySetup = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [companyName, setCompanyName] = useState("");
  const [organisationName, setOrganizationName] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [industryType, setIndustryType] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [country, setCountry] = useState("");
  const [emailAddress, setEmailAddress] = useState([]);
  const [emailInput, setEmailInput] = useState("");
  const [role, setRole] = useState(null);
  const [showPermissions, setShowPermissions] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const signupData = location.state?.signupData;
  console.log(signupData, "signupData aakash");
  useEffect(() => {
    if (
      (!signupData ||
        !signupData?.email ||
        !signupData?.fullName ||
        !signupData?.password ||
        !signupData?.confirmPassword ||
        !signupData?.agreeToTerms) &&
      !signupData?.signup_uuid
    )
      navigate("/onboarding/signup");
  }, [location.state?.signupData]);

  const [fetchCompanyPermissions, { data: companyPermissionsData, isSuccess: companyPermissionsSuccess }] =
    useLazyFetchCompanyPermissionsQuery();

  const [bulkAssignSignup, { bulkAssignData }] = useBulkAssignSignupMutation();

  const updateAndNagivate = async () => {
    dispatch(addUserCompanyAccess(companyPermissionsData?.data));
    // navigate("/customers");
  };

  useEffect(() => {
    if (companyPermissionsData && companyPermissionsData?.data) updateAndNagivate();
  }, [companyPermissionsData, companyPermissionsSuccess]);

  const OptionData = [
    { value: "Technology", label: "Technology" },
    { value: "Healthcare", label: "Healthcare" },
    { value: "Finance", label: "Finance" },
  ];
  const CompanySize = [
    { value: "1-10", label: "1-10" },
    { value: "11-50", label: "11-50" },
    { value: "51-200", label: "51-200" },
  ];

  const CountryList = [
    { value: "USA", label: "USA" },
    { value: "India", label: "India" },
    { value: "UK", label: "UK" },
  ];

  const RoleList = [
    { value: 0, label: "Member" },
    { value: 1, label: "Admin" },
  ];

  useEffect(() => {
    if (step !== 4) return;

    const timer = setTimeout(() => {
      navigate("/customers");
    }, 4000);

    return () => clearTimeout(timer); // cleanup on unmount or dependency change
  }, [step]);

  const checkOrgExists = async (org_name) => {
    try {
      const response = await fetch(`${CHECK_ORG_DUPLICATE}?org_name=${companyName}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data?.exists) {
        setErrorMessage((prev) => ({
          ...prev,
          companyName: "Company Name Already Exists",
        }));
      } else {
        setErrorMessage((prev) => {
          const { companyName, ...rest } = prev || {};
          return rest;
        });
      }
    } catch (error) {
      console.error("Error checking organization name:", error);
    }
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "organisationName":
        setOrganizationName(value);
        await checkOrgExists(value);

        if (isDisabled) {
          setCompanyName(value);
        }
        break;

      case "companyName":
        setCompanyName(value);
        break;

      case "companyWebsite":
        setCompanyWebsite(value);
        break;

      default:
        break;
    }
  };

  const handleNext = async () => {
    console.log("Step before increment:", step);
    setStep(step + 1);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  const handleSubmit = () => {
    setStep(step + 1);
  };

  const handleSubmitSection1 = async () => {
    if (errorMessage?.companyName) {
      return;
    }

    if (!companyName) {
      setErrorMessage((prev) => ({
        ...prev,
        companyName: "Company Name is required",
      }));
      return;
    }
    if (!organisationName) {
      setErrorMessage((prev) => ({
        ...prev,
        organisationName: "Organisation Name is required",
      }));
      return;
    } else {
      setErrorMessage((prev) => {
        const { companyName, ...rest } = prev || {};
        return rest;
      });
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!companyWebsite) {
      setErrorMessage((prev) => ({
        ...prev,
        companyWebsite: "Company email is required",
      }));
      return;
    }

    // if (!emailRegex.test(companyWebsite)) {
    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     companyWebsite: "Please enter a valid email address",
    //   }));
    //   return;
    // }

    // Clear any previous error for companyWebsite
    setErrorMessage((prev) => {
      const { companyWebsite, ...rest } = prev || {};
      return rest;
    });

    setErrorMessage(null);

    const apiPostData = {
      org_name: organisationName,
      company_name: companyName,
      org_website: companyWebsite,
    };

    if (signupData?.signup_uuid) {
      apiPostData["signup_uuid"] = signupData?.signup_uuid;
    } else {
      apiPostData["email"] = signupData?.email;
      apiPostData["full_name"] = signupData?.fullName;
      apiPostData["password"] = signupData?.password;
    }

    try {
      const response = await fetch(signupData?.signup_uuid ? SIGNUP_URL_GOOGLE : SIGNUP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(apiPostData),
      });

      const data = await response.json();

      dispatch(
        addParticularCompany({
          company_id: data?.data?.company?.id,
          company_name: data?.data?.company?.company_name,
          company_logo: data?.data?.company?.company_logo,
          menuName: "",
        })
      );

      if (data.user_id !== getUserId()) localStorage.removeItem("saved_view");

      dispatch(addUser(data?.data));
      localStorage.setItem("ownerInfo", JSON.stringify({ isOwner: Boolean(data?.data?.super_admin) }));

      if (data?.company_set === 1) {
        dispatch(updateUser(data?.data));
      }

      const DataAwait = await fetchCompanyPermissions({ token: getUserToken(), companyId: data?.data?.company?.id });

      setStep(step + 1);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    // setStep(step + 1);
  };

  const handleSubmitBulkDelegation = async () => {
    console.log("Submitting bulk delegation with emailAddress:", emailAddress, role);

    try {
      const payload = { emails: emailAddress, groupType: role };

      const res = await bulkAssignSignup({ payload: payload }).unwrap();

      if (res?.success) {
        setStep(step + 1);
      }
    } catch (error) {}
  };

  // Modified handler for View Permissions button
  const handleViewPermissions = (e) => {
    e.preventDefault(); // Prevent any default behavior
    setShowPermissions(true);
  };

  return (
    <main className="h-full w-1/2 flex flex-col bg-white px-4 font-Inter relative ">
      {step > 1 && (
        <div className="flex justify-start p-6">
          <button onClick={handleBack} className="text-base text-black flex items-center gap-3">
            <BackArrowIcon />
            <span className="text-base font-medium text-[#1A1A1A]">Back</span>
          </button>
        </div>
      )}
      <div className="flex-grow flex items-center justify-center">
        <div className={`w-full  bg-white rounded-md  p-6 ${step === 4 ? "max-w-2xl" : "max-w-xl"}`}>
          {step === 1 && (
            <section>
              <div className="flex flex-col items-center justify-center">
                <div className="bg-[#F4F6F8] px-8 py-2 rounded-3xl text-base">
                  Welcome, <span className="text-[#9B51E0] font-bold">{signupData?.fullName}</span>
                </div>
                <h2 className="text-2xl font-bold text-[#0D426D] mb-6 mt-2 text-center">Let’s Set Up Organisation</h2>
              </div>
              <form
                className="flex flex-col gap-6"
                onSubmit={(e) => {
                  handleSubmitSection1();
                }}
              >
                <div>
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between">
                      <label className="block text-base font-medium text-[#313131cc]">
                        Organisation Name<span className="text-[#F84545]">*</span>
                      </label>
                      {errorMessage?.organisationName && (
                        <p className="text-F16136 text-xs">{errorMessage.organisationName}</p>
                      )}
                    </div>

                    <InputComponent
                      type="text"
                      name="organisationName"
                      placeholder="Enter organisation name"
                      value={organisationName}
                      onChange={(e) => handleInputChange(e)}
                      className={`w-full  border-[#DFE2E5] rounded-md `}
                      mandatory
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2 whitespace-nowrap">
                    Please enter your organisation name to help us set up your company
                  </p>
                </div>

                <div>
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between">
                      <label className="block text-base font-medium text-[#313131cc]">
                        Company Name<span className="text-[#F84545]">*</span>
                      </label>
                      {errorMessage?.companyName && <p className="text-F16136 text-xs">{errorMessage.companyName}</p>}

                      <label className="flex items-center gap-2  text-[#1D4469] text-base">
                        <input
                          type="checkbox"
                          className="text-[#1D4469] border border-[#1D4469] rounded outline-none focus:outline-none focus:ring-0 focus:ring-transparent"
                          checked={isDisabled}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setIsDisabled(checked);

                            if (checked) {
                              setCompanyName(organisationName);
                            }
                          }}
                        />
                        <span className="text-sm font-normal text-[#666]">Same as Organisation</span>
                      </label>
                    </div>

                    <InputComponent
                      type="text"
                      name="companyName"
                      placeholder="Enter company name"
                      value={companyName}
                      onChange={(e) => handleInputChange(e)}
                      className={`w-full  border-[#DFE2E5] rounded-md `}
                      isDisabled={isDisabled}
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2">
                    Please enter your official company registered name
                  </p>
                </div>

                <div>
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between">
                      <label className="block text-base font-medium text-[#313131cc]">
                        Company Website<span className="text-red-500">*</span>
                      </label>
                      {errorMessage?.companyWebsite && (
                        <p className="text-F16136 text-xs">{errorMessage.companyWebsite}</p>
                      )}
                    </div>
                    <InputComponent
                      type="url"
                      name="companyWebsite"
                      placeholder="Enter company website URL (e.g. www.yourcompany.com)"
                      value={companyWebsite}
                      onChange={(e) => handleInputChange(e)}
                      className={`w-full border-[#DFE2E5] rounded-md `}
                      mandatory
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2">
                    Enter a valid website URL (e.g., www.yourcompany.com)
                  </p>
                </div>
                <div className="bg-[#1e3a8a0f] text-[#0D426D]  rounded-md p-6 text-base flex flex-col gap-1">
                  <p className="font-medium  flex items-center gap-2">
                    <PencilIcon />
                    <span className="text-[#1E3A8A] text-lg font-medium">Note</span>
                  </p>
                  <p className="text-[#1e3a8acc] text-base font-normal">
                    After completing your company setup, you can easily add multiple companies to your account.
                  </p>
                </div>
              </form>
            </section>
          )}
          {step === 2 && (
            <section>
              <h2 className="text-3xl font-bold text-[#0D426D] pb-6">Complete Your Business Profile</h2>
              <form className="flex flex-col gap-8">
                <div>
                  <div className="flex flex-col gap-3">
                    <label className="block text-base font-medium text-[#313131cc]">Industry Type</label>
                    <BasicSelect
                      options={OptionData}
                      inputBoxSize="medium"
                      name={"industry_type"}
                      label="Industry"
                      value={industryType}
                      size="medium"
                      onChange={(e) => setIndustryType(e.target.value)}
                      // selectedOptions={OptionData}
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2">Please enter your industry type</p>
                </div>
                <div>
                  <div className="flex flex-col gap-3">
                    <label className="block text-base font-medium text-[#313131cc]">Company Size</label>
                    <BasicSelect
                      options={CompanySize}
                      inputBoxSize="medium"
                      name={"company_size"}
                      label="Company Size"
                      value={companySize}
                      size="medium"
                      onChange={(e) => setCompanySize(e.target.value)}
                      // selectedOptions={CompanySize}
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2">Please enter your company size</p>
                </div>
                <div>
                  <div className="flex flex-col gap-3">
                    <label className="block text-base font-medium text-[#313131cc]">Country</label>
                    <BasicSelect
                      options={CountryList}
                      inputBoxSize="medium"
                      name={"country"}
                      label="Country"
                      value={country}
                      size="medium"
                      onChange={(e) => setCountry(e.target.value)}
                      // selectedOptions={CountryList}
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2">Please enter your company location</p>
                </div>
              </form>
            </section>
          )}
          {step === 3 && (
            <section>
              <h2 className="text-3xl font-bold text-[#0D426D] pb-6">Collaborate with Your Team</h2>
              <form className="flex flex-col gap-8">
                <div>
                  <div className="flex flex-col gap-3">
                    <label className="block text-base font-medium text-[#313131cc]">Email Address</label>
                    <InputComponent
                      type="email"
                      placeholder="Enter email address"
                      value={emailInput}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setEmailInput(inputValue);

                        const emails = inputValue
                          .split(";")
                          .map((email) => email.trim())
                          .filter((email) => email !== "");

                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        const allValid = emails.every((email) => emailRegex.test(email));

                        if (allValid) {
                          setEmailAddress(emails);
                          setErrorMessage((prev) => {
                            const { email, ...rest } = prev || {};
                            return rest;
                          });
                        } else {
                          setErrorMessage((prev) => ({
                            ...prev,
                            email: "One or more email addresses are invalid.",
                          }));
                        }
                      }}
                      className={`w-full border-[#DFE2E5] rounded-md `}
                    />
                  </div>
                  <p className="text-base text-[#1a1a1a99] font-normal pt-2 text-clip whitespace-nowrap">
                    You can add multiple email address separated by semi-colon (;)
                  </p>
                </div>
                <div>
                  <div className="flex flex-col gap-3">
                    <label className="block text-base font-medium text-[#313131cc]">Role</label>
                    <BasicSelect
                      options={RoleList}
                      inputBoxSize="medium"
                      selectedOptions={RoleList.filter((item) => item.value === role)}
                      size="medium"
                      onChange={(e) => setRole(e.target.value)}
                      // selectedOptions={CountryList}
                    />
                  </div>
                  <p className="ext-base text-[#1a1a1a99] font-normal pt-2">
                    Not sure which role to assign?{" "}
                    <button
                      onClick={handleViewPermissions} // Updated to use new handler
                      className="text-[#1a1a1a99]  underline"
                      type="button" // Explicitly set to prevent form submission
                    >
                      View Permissions
                    </button>
                  </p>
                </div>
                <div className="bg-[#1e3a8a0f] text-[#0D426D]  rounded-md p-6 text-base flex flex-col gap-1">
                  <p className="font-medium  flex items-center gap-2">
                    <PencilIcon />
                    <span className="text-[#1E3A8A] text-lg font-medium">Note</span>
                  </p>
                  <p className="text-[#1e3a8acc] text-base font-normal">
                    After completing your company setup, you can easily add multiple companies to your account.
                  </p>
                </div>
              </form>
            </section>
          )}
          {step === 4 && (
            <section className="text-center bg-[#f8faffcc] p-20 ">
              <h2 className="text-3xl font-bold text-[#1D4469] pb-6">Nice work! We're building your space...</h2>
              <p className="text-base text-[#1a1a1a99] pb-4 px-8">
                Manage daily bookkeeping and ledgers effortlessly. Generate automated, real-time financial reports.
              </p>
              <div className="flex justify-center pb-6">
                <img src={LoaderGif} alt="Add Icon" className="w-20 h-20 object-cover rounded-full" />
              </div>

              <p className="text-2xl text-[#1a1a1a99] font-medium">Getting things ready for you...</p>
            </section>
          )}
          <footer className="pt-6 flex justify-end items-center gap-4">
            {step > 1 && step < 4 && (
              <button
                onClick={handleNext}
                className="bg-white hover:bg-gray-100 text-[#1D4469] border border-[#1D4469] py-2 px-6 rounded-md font-medium text-base"
              >
                Skip
              </button>
            )}
            {step < 4 && (
              <button
                onClick={() => {
                  if (step === 1) {
                    handleSubmitSection1();
                  } else if (step === 2) {
                    handleNext();
                  } else if (step == 3) {
                    handleSubmitBulkDelegation();
                  } else {
                    handleSubmit();
                  }
                }}
                className="bg-[#0D426D] hover:bg-[#093559] text-white py-2 px-6 rounded-md font-medium text-base"
              >
                {step < 3 ? "Continue" : "Submit"}
              </button>
            )}
          </footer>
          {step < 4 && (
            <>
              <div className="border-t border-dashed border-[#DFE2E5]  m-auto mt-2" />
              <div className="mt-4 text-base flex items-center gap-2 text-gray-600 bg-[#F8F8F8] p-4 rounded-md">
                <span className=" text-xl">
                  <SecurityIcon />
                </span>
                <span>Your information is secure and will only be used to set up your company profile</span>
              </div>
            </>
          )}
        </div>
      </div>
      {showPermissions && (
        <>
          <div className="absolute inset-0 bg-black bg-opacity-40" />
          <div className="absolute inset-0 ">
            <PermissionHelper onClose={() => setShowPermissions(false)} />
          </div>
        </>
      )}
    </main>
  );
};

export default CompanySetup;
